// Signature Pad
// https://github.com/szimek/signature_pad

(function ($) {
    "use strict";
    var SignaturePad = require("signature_pad");
    var SELECTOR = "[data-signature-pad]";
    var CANVAS_SELECTOR = "[data-signature-pad-canvas]";
    var CLEAR_SELECTOR = "[data-signature-pad-clear]";
    var INPUT_SELECTOR = "[data-signature-pad-input]";
    var CHECKBOX_CONFIRMATION = "[data-signature-pad-confirmation]";
    var ERROR_SELECTOR = "[data-signature-pad-error]";
    var SUCCESS_SELECTOR = "[data-signature-pad-success]";
    var WITH_GRID = false;
    var WITH_ZONES = false;

    var wrapper = document.querySelector(SELECTOR);
    if (!wrapper) return;
    var canvas = wrapper.querySelector(CANVAS_SELECTOR);
    var clearBtn = wrapper.querySelector(CLEAR_SELECTOR);
    var input = wrapper.querySelector(INPUT_SELECTOR);
    var checkboxConfirmation = wrapper.querySelector(CHECKBOX_CONFIRMATION);
    var $checkbox = $(checkboxConfirmation);
    var errorAlert = wrapper.querySelector(ERROR_SELECTOR);
    var successAlert = wrapper.querySelector(SUCCESS_SELECTOR);

    if (!isCanvasSupported()) {
        console.warn("[Signature Pad] Canvas is not supported.");
        wrapper.classList.add("d-none");
        $checkbox.prop('disabled', true);
        return;
    }

    var signaturePad = new SignaturePad(canvas);

    if (WITH_GRID) {
        wrapper.classList.add('signature-pad--with-grid');
    }

    if (WITH_ZONES) {
        wrapper.classList.add('signature-pad--with-zones');
    }

    signaturePad.addEventListener("endStroke", function () {
        if (!input) {
            console.warn('[SignaturePad] No input found.');
            return;
        }

        var validation = validateSignature(data);
        updateForm(validation.isValid, validation.infos);

        var data = getSignatureData();
        input.value = data;
    });

    clearBtn.addEventListener("click", function () {
        signaturePad.clear();
        updateForm(false);
    });

    function updateForm(isValid, infos) {
        if (isValid) {
            errorAlert.classList.add('u-is-hidden');
            successAlert.classList.remove('u-is-hidden');
            $checkbox.closest('.checkbox').removeClass('is-readonly');
            wrapper.removeAttribute('data-signature-pad-invalid');
        } else {
            errorAlert.classList.remove('u-is-hidden');
            successAlert.classList.add('u-is-hidden');
            $checkbox.prop('checked', false);
            $checkbox.closest('.checkbox').addClass('is-readonly');
            $('[data-signature-button]').prop('disabled', true).toggleClass('disabled', true);
            wrapper.removeAttribute('data-signature-pad-invalid');

            if (infos) {
                var invalidZoneIds = infos.map(function(zone) {
                    if (!zone.isValid) return zone.id;
                });
                wrapper.setAttribute('data-signature-pad-invalid', invalidZoneIds.join(' '));
            }
        }
    }

    function validateSignature() {
        var width = canvas.width;
        var height = canvas.height;
        var zones = [
            {
                id: 'top_left',
                top: 0,
                left: 0,
                right: width / 2,
                bottom: height / 2
            },
            {
                id: 'top_right',
                top: 0,
                left: width / 2,
                right: width,
                bottom: height / 2
            },
            {
                id: 'bottom_left',
                top: height / 2,
                left: 0,
                right: width / 2,
                bottom: height
            },
            {
                id: 'bottom_right',
                top: height / 2,
                left: width / 2,
                right: width,
                bottom: height
            }
        ];

        // Data
        var strokes = signaturePad.toData();
        var points = strokes.flatMap(function(stroke) {
            return stroke.points.map(function(point) {
                return { x: point.x, y: point.y };
            });
        });

        // Validations
        var validatedZones = zones.map(function(zone) {
            return points.some(function(point) {
                return isBetween(zone.left, zone.right, point.x) && isBetween(zone.top, zone.bottom, point.y);
            });
        });

        var withInfos = validatedZones.map(function(isValid, index) {
            var zone = zones[index];
            return Object.assign(zone, { isValid: isValid });
        });

        var isValid = withInfos.filter(function(zone) {return zone.isValid === true}).length >= withInfos.length / 2;

        return {
            isValid: isValid,
            infos: withInfos
        };
    }

    function getSignatureData() {
        if (signaturePad.isEmpty()) {
            console.warn("[Signature Pad] Please provide a signature first.");
            return;
        }

        // https://github.com/szimek/signature_pad/issues/675#issuecomment-1315670878
        var dpi = window.devicePixelRatio;
        window.devicePixelRatio = 1;
        var dataUrl = signaturePad.toDataURL("image/svg+xml");
        window.devicePixelRatio = dpi;
        return dataUrl;
    }

    function isCanvasSupported() {
        return !!document.createElement("canvas").getContext;
    }

    function resizeCanvas() {
        var ratio = 1; // SignaturePad have issues with zoom and devicePixelRatio, defaulting ratio to 1 seems to fix the issues
        var canvasSizeChanged = false;

        if (parseInt(canvas.width) !== parseInt(canvas.offsetWidth * ratio)) {
            canvas.width = parseInt(canvas.offsetWidth * ratio);
            canvasSizeChanged = true;
        }
        if (parseInt(canvas.height) !== parseInt(canvas.offsetHeight * ratio)) {
            canvas.height = parseInt(canvas.offsetHeight * ratio);
            canvasSizeChanged = true;
        }

        canvas.getContext("2d").scale(ratio, ratio);

        if (canvasSizeChanged) {
            signaturePad.clear();
        }
    }

    function isBetween(start, end, value) {
        return value > start && value < end;
    }

    $('#steps-signlease-tab').on('shown.bs.tab', function (e) {
        window.addEventListener("resize", resizeCanvas);
        resizeCanvas();
    });

    $('#steps-signlease-tab').on('hide.bs.tab', function (e) {
        window.removeEventListener("resize", resizeCanvas);
    });
})(require('jquery'));
